import {
  type AccountOverviewOrderStatusWithDate,
  type OrderStatusConfigLabels,
  type OrderStatusProps,
} from './AccountOverviewLastOrderShippingStatusTypes'

const getFormattedShippingStatusMessage = ({
  deliveryDate,
  isNowOrder,
  shippingStatusLabels,
  timeRange,
}: Omit<AccountOverviewOrderStatusWithDate, 'orderStatus'>):
  string | undefined => {
  if (isNowOrder && timeRange) {
    return `${shippingStatusLabels.shipped}: `
  }
  if (deliveryDate) {
    return `${shippingStatusLabels.shipped}: ${deliveryDate}`
  }

  return undefined
}

export const userSubOrderShippingStatusMessageAndColor = ({
  deliveryDate,
  isNowOrder,
  orderStatus,
  shippingStatusLabels,
  timeRange,
}: AccountOverviewOrderStatusWithDate): OrderStatusProps => {
  const orderShippingStatusMap: Record<
    OrderStatusConfigLabels,
    OrderStatusProps
  > = {
    canceled: {
      color: 'text-dark-primary-strong',
      lastOrderOrderStatus: orderStatus,
      message: shippingStatusLabels.canceled,
    },
    cancelRequested: {
      color: 'text-dark-note',
      lastOrderOrderStatus: orderStatus,
      message: shippingStatusLabels.cancelRequested,
    },
    closed: {
      color: 'text-dark-primary-strong',
      lastOrderOrderStatus: orderStatus,
      message: shippingStatusLabels.closed,
    },
    completed: {
      color: 'text-dark-success',
      lastOrderOrderStatus: orderStatus,
      message: shippingStatusLabels.completed,
    },
    delivered: {
      color: 'text-dark-success',
      lastOrderOrderStatus: orderStatus,
      message: deliveryDate
        ? `${shippingStatusLabels.delivered} ${deliveryDate}`
        : shippingStatusLabels.delivered,
    },
    dispatched: {
      color: 'text-dark-success',
      lastOrderOrderStatus: orderStatus,
      message: shippingStatusLabels.dispatched,
    },
    new: {
      color: 'text-dark-secondary',
      lastOrderOrderStatus: orderStatus,
      message: shippingStatusLabels.new,
    },
    processing: {
      color: 'text-dark-secondary',
      lastOrderOrderStatus: orderStatus,
      message: shippingStatusLabels.processing,
    },
    readyForPickup: {
      color: 'text-dark-success',
      lastOrderOrderStatus: orderStatus,
      message: shippingStatusLabels.readyForPickup,
    },
    shipped: {
      color: 'text-dark-success',
      lastOrderOrderStatus: orderStatus,
      message: getFormattedShippingStatusMessage({
        deliveryDate,
        isNowOrder,
        shippingStatusLabels,
        timeRange,
      }),
    },
    waitingForPrepayment: {
      color: 'text-dark-note',
      lastOrderOrderStatus: orderStatus,
      message: shippingStatusLabels.waitingForPrepayment,
    },
  }

  return orderShippingStatusMap[orderStatus]
}
